/* eslint-disable react/display-name */
import { navigate } from "gatsby"
import { useEffect, useState } from "react"

import {
  customerIoClient,
  marketingClient,
  orderClient,
  useMutation,
  useQueryClient,
} from "@trueskin-web/apis"
import { Routes } from "@trueskin-web/translations"

const withPresetsActions =
  (Component) =>
  ({ presetList, ...props }) => {
    const queryClient = useQueryClient()

    const [selectedPlanId, setSelectedPlanId] = useState()

    const {
      mutateAsync: setCurrentPreset,
      status,
      error: submitError,
    } = useMutation(orderClient.setCurrentPreset, {
      onSuccess: ({ data }) =>
        (async ({ customer, preset, values }) => {
          const eventData = {
            userId: customer,
            presetId: preset,
            currency: values.currency,
            value: values.total,
          }

          marketingClient.sendEvent({
            name: marketingClient.EVENT_TYPES_ENUM.PRODUCT_SELECTED,
            data: eventData,
          })
          marketingClient.sendEvent({
            name: marketingClient.EVENT_TYPES_ENUM.SELECT_PAYMENT_OPTION,
            data: eventData,
          })

          customerIoClient.track(
            customerIoClient.EVENT_NAMES.PRODUCT_SELECTION_CONFIRMED,
            {
              planId: preset,
            }
          )

          await Promise.all([
            queryClient.invalidateQueries("currentPresets"),
            queryClient.invalidateQueries("currentOrderSummary"),
          ])
        })(data),
    })

    const handleSelect = (planId) => {
      setSelectedPlanId(planId)
      marketingClient.sendEvent({
        name: marketingClient.EVENT_TYPES_ENUM.PRODUCT_CLICKED,
        data: { presetId: planId },
      })
      customerIoClient.track(customerIoClient.EVENT_NAMES.PRODUCT_SELECTED, {
        planId: planId,
      })
    }

    const handleSubmit = async (planId) => {
      await setCurrentPreset(planId)
      navigate(Routes.App.Start.Shipping.url)
    }

    useEffect(() => {
      const preselectedPlan =
        presetList.find(({ isSelected }) => isSelected) ||
        presetList.find(({ summary }) => summary.instalments.count === 2)

      if (preselectedPlan) {
        setSelectedPlanId(preselectedPlan.id)
      }
    }, [presetList])

    return (
      <Component
        {...props}
        presetList={presetList}
        selectedPlanId={selectedPlanId}
        onSelect={handleSelect}
        onSubmit={handleSubmit}
        isSubmitting={status === "loading"}
        submitError={submitError}
      />
    )
  }

export default withPresetsActions
